import React, { useState, useEffect } from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faCar,
  faCalendar,
  faUser,
  faRulerCombined,
  faGasPump,
  faCubes,
  faFile
} from "@fortawesome/free-solid-svg-icons";
import { Col, Row, Card, Badge, Container } from '@themesberg/react-bootstrap';

export default ({ data }) => {
  const [vehicle, setVehicle] = useState(null);
  const [isActive, setIsActive] = useState(false);

  const formatDate = (isoDate) => {
    if (!isoDate) return "-";
    const date = new Date(isoDate);
    return date.toLocaleString("en-IN", {
      day: "numeric",
      month: "long",
      year: "numeric",
    });
  };

  useEffect(() => {
    const v = data?.vehicle?.[0] || data;

    if (v) {
      console.log("Vehicle Data:", v);
      setVehicle(v);
      setIsActive(v.is_active);
    }
  }, [data]);

  if (!vehicle) return null;

  return (
    <main>
      <Container className="px-0" style={{ backgroundColor: `#ffffff` }}>
        <section className="d-flex justify-content-between align-items-center border-bottom mb-4">
          <Container>

            {/* <div className="d-flex justify-content-between align-items-center mb-3">
              <h5 className="mb-0">Vehicle Details</h5>
              <Badge bg={isActive ? "success" : "danger"}>
                {isActive ? "Active" : "Inactive"}
              </Badge>
            </div> */}

            <Row className="g-1">

                <Col md={15}>
                    <div className="border rounded">

                    {[
                        ["Vehicle Number", vehicle.vehicle_number],
                        ["Vehicle Type", vehicle.vehicle_type_name],
                        ["Maker", vehicle.maker_name],
                        ["Model", vehicle.model_name],
                        ["Fuel Type", vehicle.fuel_type_name],
                        ["Body Type", vehicle.body_type_name],
                        ["Load Capacity (Ton)", vehicle.load_capacity],
                        ["Volume", vehicle.volume],
                        ["Dimensions (L×W×H)", `${vehicle.length} × ${vehicle.width} × ${vehicle.height}`],
                        ["Owner Type", (vehicle.owner_type == 1) ? "SELF" : (vehicle.owner_type == 2) ? "THIRD-PARTY" : "-"],
                        ["Owner Name", vehicle.owner_name],
                        ["Pollution Number", vehicle.pollution_number],
                        ["Registration Issue Date", formatDate(vehicle.registration_issue_date)],
                        ["Registration Expiry Date", formatDate(vehicle.registration_expiry_date)],
                        ["Pollution Expiry Date", formatDate(vehicle.pollution_expiry_date)],
                        ["Insurance Number", vehicle.insurance_number],
                        ["Insurance Expiry Date", formatDate(vehicle.insurance_expiry_date)],
                        ["Created At", formatDate(vehicle.created_at)],
                        ["Updated At", formatDate(vehicle.updated_at)],
                    ].map((item, index) => (
                        <Row key={index} className="py-2 border-bottom m-0">

                        {/* Label */}
                        <Col
                            md={6}
                            style={{
                            borderRight: "1px solid #ddd",
                            fontWeight: "600",
                            background: "#fafafa"
                            }}
                        >
                            {item[0]}
                        </Col>

                        {/* Value */}
                        <Col md={6}>
                            {item[1] || "-"}
                        </Col>

                        </Row>
                    ))}

                    {/* Status */}
                    <Row className="py-2 m-0">
                        <Col
                        md={6}
                        style={{
                            borderRight: "1px solid #ddd",
                            fontWeight: "600",
                            background: "#fafafa"
                        }}
                        >
                        Status
                        </Col>
                        <Col md={6}>
                        <Badge bg={vehicle.is_active ? "success" : "danger"}>
                            {vehicle.is_active ? "Active" : "Inactive"}
                        </Badge>
                        </Col>
                    </Row>

                    </div>
                </Col>

                </Row>
          </Container>
        </section>
      </Container>
    </main>
  );
};